import {FieldsForm} from '../fields/types'
import {useFormContext} from 'react-hook-form'

export const useOrderProcessFormContext = () => useFormContext<FieldsForm>()
